import AppOptions from "@core/app/options";

class StoredData<T> {
    expiresAt: number;
    payload: T
}

class LocalStorage {
    constructor(
        protected options: AppOptions
    ) { }

    get<T>(key: string, defValue: T|null = null): T | null {
        let data: string | null;

        try {
            data = localStorage.getItem(key);
        } catch {
            return defValue;
        }

        if (!data) {
            return defValue;
        }

        let storedData: StoredData<T>;

        try {
            storedData = JSON.parse(data);
        } catch {
            app.log('Bad data in local storage', key, data);
            return defValue;
        }

        if (storedData.expiresAt < 0 || storedData.expiresAt > Date.now()) {
            return storedData.payload;
        }

        this.remove(key);
        return defValue;
    }

    /**
     * Set expireMinutes to -1 if you don't want cache to expire.
     */
    set<T>(key: string, payload: T, expireMinutes: number = -1): void {
        const expiresAt = expireMinutes > 0 ? Date.now() + expireMinutes * 60 * 1000 : -1;
        const storedData: StoredData<T> = { payload, expiresAt };

        try {
            localStorage.setItem(key, JSON.stringify(storedData));
        } catch { }
    }

    remove(key: string): void {
        try {
            localStorage.removeItem(key);
        } catch { }
    }
}

export default LocalStorage;